import {Component, OnInit} from '@angular/core';
import {LayoutService} from './service/app.layout.service';
import {UntilDestroy} from '@ngneat/until-destroy';
import {DialogService} from 'primeng/dynamicdialog';
import {ReloadDataService} from '../services/reload-data.service';
import {Routing} from '../models/routing/routing';
import {TranslateService} from '@ngx-translate/core';
import {Translations} from '../services/translations.service';
import {SessionStorageService} from '../services/session-storage.service';
import {AclPermission} from '../models/acl/acl-group';
import {MenuItem} from 'primeng/api';
import {Router} from '@angular/router';
import {NgForOf} from '@angular/common';
import {AppMenuitemComponent} from './app.menuitem.component';
import {ProfileButtonComponent} from '../components/profile-button/profile-button.component';
import {User} from '../models/user';
import {environment} from '../../environments/environment';

@UntilDestroy()
@Component({
  standalone: true,
  selector: 'app-menu',
  imports: [
    NgForOf,
    AppMenuitemComponent,
    ProfileButtonComponent
  ],
  templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
  user: User = new User();

  model: MenuItemEx[] = [];

  get mainModel() {
    return this.model.filter(item => !item.bottom);
  }

  get bottomModel() {
    return this.model.filter(item => item.bottom);
  }


  constructor(public layoutService: LayoutService,
              private reloadDataService: ReloadDataService,
              private dialogService: DialogService,
              public translations: Translations,
              private translateService: TranslateService,
              private router: Router,
              private sessionService: SessionStorageService,
              private session: SessionStorageService) {
    this.user = sessionService.userData;
  }

  ngOnInit() {
    this.translateService.onLangChange.subscribe(() => this.initMenu());
    this.initMenu();
  }

  initMenu() {
    this.model = [
      {
        label: 'Gestione catalogo',
        icon: 'pi pi-home',
        routerLink: [Routing.dashboard.getBasePath()],
      },
      {
        label: 'Anteprima catalogo',
        icon: 'pi pi-eye',
        url: environment.host,
        target: '_blank',
      },
      {
        styleClass: 'separator',
        separator: true
      },
      {
        label: 'Aggiungi titolo',
        icon: 'pi pi-plus',
        routerLink: [Routing.movies.new()],
      },
      {
        label: 'Importa Excel',
        icon: 'pi pi-file-excel',
        routerLink: [Routing.movies.catalogueImport()],
      }
    ];

    this.model.push({
      label: 'Gestione Generi',
      icon: 'pi pi-tags',
      routerLink: [Routing.genres.getBasePath()],
      bottom: true
    });

    this.model.push({
      label: 'Gestione Slider',
      icon: 'pi pi-sliders-h',
      routerLink: [Routing.carousel.getBasePath()],
      bottom: true
    });

    if (this.session.hasPermission(AclPermission.AdminUsers)) {
      this.model.push({
        label: 'Users',
        icon: 'pi pi-users',
        routerLink: [Routing.users.getBasePath()],
        bottom: true
      });
    }

    if (this.session.hasPermission(AclPermission.AclManagement)) {
      this.model.push({
        label: 'ACL',
        icon: 'pi pi-lock',
        routerLink: [Routing.acl.getBasePath()],
        bottom: true
      });
    }
  }

}

interface MenuItemEx extends MenuItem {
  bottom?: boolean;
}
